import { defineStore } from 'pinia'
import { ref } from 'vue'

import api from '@app/insights/api'

interface SubmissionType {
  key: string
  text: string
}

interface SubmissionStatus {
  key: string
  text: string
}

interface SubmissionData {
  submission_types?: SubmissionType[]
  statuses?: SubmissionStatus[]
}

export const useSubmissionsStore = defineStore('insights-submissions', () => {
  const submissionData = ref<SubmissionData>({})

  async function fetchSubmissionDropdownData(): Promise<void> {
    const data = (await api.fetchSubmissionDropdownData()) as SubmissionData
    submissionData.value = data
  }

  return {
    submissionData,
    fetchSubmissionDropdownData,
  }
})
